import { atomWithStorage } from "jotai/utils";

export interface UnregisterData {
  ReferenceId: string;
  EditId: string;
  email?: string;
}

export const unregisterDataAtom = atomWithStorage<UnregisterData | null>(
  "unregister-data",
  null,
  {
    getItem: (key) => {
      const value = sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    },
    setItem: (key, value) => {
      sessionStorage.setItem(key, JSON.stringify(value));
    },
    removeItem: (key) => {
      sessionStorage.removeItem(key);
    },
  }
);
